import { render, staticRenderFns } from "./endPlaceholder-editor.vue?vue&type=template&id=373a69c1&scoped=true&"
import script from "./endPlaceholder-editor.vue?vue&type=script&lang=js&"
export * from "./endPlaceholder-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a69c1",
  null
  
)

export default component.exports